export default function ContactSection() {
  return (
    <section id="contact" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>匿名投稿
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            我要爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
            你有独家内幕？掌握明星出轨实锤证据或娱乐圈丑闻细节？我们提供全程匿名保护，确保爆料人信息安全。无论是文字线索、聊天截图还是录音录像，都可以通过以下渠道联系我们。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-lg p-5 text-center">
              <span className="w-12 h-12 flex items-center justify-center mx-auto bg-primary-100 text-primary-600 rounded-full mb-3">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <h3 className="font-semibold text-sm text-foreground-800 mb-1">邮箱投稿</h3>
              <p className="text-xs text-foreground-400">tips@chiguaheiliaoboliao.com</p>
            </div>
            <div className="bg-background-50 rounded-lg p-5 text-center">
              <span className="w-12 h-12 flex items-center justify-center mx-auto bg-accent-100 text-accent-600 rounded-full mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </span>
              <h3 className="font-semibold text-sm text-foreground-800 mb-1">微信投稿</h3>
              <p className="text-xs text-foreground-400">chigua_tips</p>
            </div>
            <div className="bg-background-50 rounded-lg p-5 text-center">
              <span className="w-12 h-12 flex items-center justify-center mx-auto bg-secondary-100 text-secondary-600 rounded-full mb-3">
                <i className="ri-phone-line text-xl"></i>
              </span>
              <h3 className="font-semibold text-sm text-foreground-800 mb-1">热线电话</h3>
              <p className="text-xs text-foreground-400">400-888-XXXX</p>
            </div>
          </div>

          <p className="text-xs text-foreground-400">
            * 所有投稿均采用端到端加密传输，严格保护爆料人隐私
          </p>
        </div>
      </div>
    </section>
  );
}